import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import ChannelCard from './ChannelCard.jsx';
import './css/recommended.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import SwiperCore, { Navigation } from 'swiper';
import { useNavigate } from 'react-router';
import ChannelCardSkeleton from '../../../../skeleton/channelSkeleton/ChannelCardSkeleton.jsx';
import { EVENT, ON_VIEW_ALL_BUTTON_CLICK } from '../../../../TrackerFolder/constants/ActionType.js';
import { onViewAllClick, trackEvent } from '../../../../TrackerFolder/actions/UserActions.js';
import { useTracker } from '../../../../TrackerFolder/TrackerComponent';
SwiperCore.use([Navigation]);
const RecommendedChannel = (props) => {
  const suggestionData = props.data;
  const loader = props.loader;
  const { trackActivityEvent } = useTracker();
  const navigate = useNavigate();

  function viewAllActivity() {
    trackActivityEvent(ON_VIEW_ALL_BUTTON_CLICK, onViewAllClick('Channel'));
    navigate('/ChannelSuggestion');
  }

  return (
    <div className="w-100 chnlYouLike">
      <div className="d-flex align-items-center justify-content-between">
        <h4 className="text-black fs-2 fw-semibold text-start">You may also like</h4>
        <a
          href="javascript:void(0)"
          className="rippleEffect fs-4 fw-medium gtm_cl_channel_manage_recomendedChannel_youMayAlsoLike_explore_more"
          onClick={() => {
            viewAllActivity();
            trackActivityEvent(EVENT, trackEvent('VIEW_ALL_BUTTON_CLICKED'));
          }}
        >
          Explore More
        </a>
      </div>

      <div className="clearfix"></div>

      <div className="w-100 chnlYouLikeArea">
        <Swiper
          spaceBetween={15}
          slidesPerView={5.2}
          loop={false}
          navigation={false}
          breakpoints={{
            1: {
              slidesPerView: 2.2,
              spaceBetween: 5
            },
            640: {
              slidesPerView: 3.2,
              spaceBetween: 5
            },
            768: {
              slidesPerView: 4.2,
              spaceBetween: 10
            },
            992: {
              slidesPerView: 5.2,
              spaceBetween: 15
            },
            1400: {
              slidesPerView: 6.2,
              spaceBetween: 20
            }
          }}
        >
          {!loader
            ? suggestionData.map((singleData, index) => {
                return (
                  <SwiperSlide key={index + 1}>
                    <ChannelCard data={singleData} />
                  </SwiperSlide>
                );
              })
            : loader
            ? [...Array(5).keys()].map((_i, index) => {
                return (
                  <SwiperSlide key={index + 1}>
                    <ChannelCardSkeleton />
                  </SwiperSlide>
                );
              })
            : null}
        </Swiper>
      </div>
    </div>
  );
};

export default RecommendedChannel;
